import React from "react";
import "../styles/app.css";
import ProgressBar from 'react-bootstrap/ProgressBar';

function AppProgressBar({progressPercent = 60}) {
  return <ProgressBar variant="progressCustom" now={progressPercent} /* label={`${now}%`} */ style={{ width: "100%",
    height: "1.2rem",
    color: "purple !important",
    transition: 'width 0.5s ease-in-out' }} />;
}

export default AppProgressBar;